var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.23495,
    y: 1.08285,
    width: 29.3926,
    height: 29.3926,
    rx: 14.6963,
    stroke: "#1A1A1A",
    strokeWidth: 1.14178
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9027 9.31885L23.3628 15.779L16.9261 22.2392L15.8026 21.1157L20.2498 16.6451H8.49976V14.913H20.2498L15.7791 10.4658L16.9027 9.31885Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.7c2be922d3e2c29602963d3f38a1170a.svg";
export { ForwardRef as ReactComponent };